import tenClearUrl from "../assets/audio/sfx/10clear.wav";
import buildNegativeUrl from "../assets/audio/sfx/buildnegative.wav";
import buildPositiveUrl from "../assets/audio/sfx/buildpositive.wav";
import incrementUrl from "../assets/audio/sfx/increment.wav";
import matchClearUrl from "../assets/audio/sfx/matchclear.wav";
import refillUrl from "../assets/audio/sfx/refill.wav";
import type { SoundEffectId } from "./soundEffects";

export const SOUND_EFFECT_ASSET_URLS: Record<SoundEffectId, string> = {
  match_clear: matchClearUrl,
  ten_clear: tenClearUrl,
  build_positive: buildPositiveUrl,
  build_negative: buildNegativeUrl,
  refill: refillUrl,
  increment: incrementUrl
};
